import { AppBundle } from 'api/optimalprint-sdk.d';
import { cloneDeep } from 'lodash';
import { STOCK_STATUS } from 'store/product/types';
import { ExtendedProductPageSelectorOption } from './exploreOptions';
import getProductAttributeValue from './getProductAttributeValue';

export type ProductItem = {
  product: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem & {
    avalilabilityStatus?: {
      status: string;
      label: string;
    } | null;
  };
};

const getAvailableOptions = (selector: any, products: ProductItem[]) => {
  const options = cloneDeep(selector.options) as ExtendedProductPageSelectorOption[];
  options.forEach((option) => {
    option.disabled = true;
    option.selected = false;
  });

  products.forEach((productItem) => {
    const value = getProductAttributeValue(productItem.product, selector.typeName);
    const targetOption = options.find((option) => option.value === value);
    if (targetOption && !targetOption.productId) {
      targetOption.productId = productItem.product.productId;
      targetOption.disabled = false;
      targetOption.selected = false;
    }
  });

  return options.map((option) => {
    const productsWithThisOption = products.filter((productItem) => {
      return option.value === getProductAttributeValue(productItem.product, selector.typeName);
    });
    if (
      productsWithThisOption.length &&
      productsWithThisOption.every(
        (productItem) => productItem.product.avalilabilityStatus?.status === STOCK_STATUS.STATUS_UNAVAILABLE,
      )
    ) {
      return { ...option, avalilabilityStatus: productsWithThisOption[0].product.avalilabilityStatus };
    }
    return option;
  });
};

export default getAvailableOptions;
